import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft } from 'lucide-react';
export function BarndormatoryPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-133">
      <Header data-id="element-134" />

      <main className="pt-32 pb-24 min-h-screen flex flex-col" data-id="element-135">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-136">
          <a href="/" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-137">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-138" />
            Back to Home
          </a>

          <div className="text-center max-w-4xl mx-auto" data-id="element-139">
            <div className="mb-12 flex justify-center" data-id="element-140">
              <img src="https://cdn.magicpatterns.com/uploads/8BjGD32ieUY3EYzqm5M2xt/Twice_Bourne_Logo-09.png" alt="Twice Bourne Barndormatory Logo" className="max-w-md w-full h-auto" data-id="element-141" />
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-142">
              Twice Bourne Barndormatory
            </h1>

            <p className="text-xl text-slate-300 mb-8 leading-relaxed" data-id="element-143">
              Redefining modern living spaces with rustic charm and contemporary
              architecture. We combine innovative design with sustainable
              residential properties to create unique homes that stand the test
              of time.
            </p>

            <div className="mt-12" data-id="element-144">
              <a href="https://twicebournegrouphomes.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-10 py-5 text-lg font-medium rounded-full text-slate-900 bg-white hover:bg-slate-100 transition-colors" data-id="element-145">
                Explore Our Homes
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-146" />
    </div>;
}